import { _get, _post } from "@/assets/js/http.js";
import util from "@/assets/js/util.js";
import { checkBrowser, getStorage, getUrlParam, GetUrlRelativePath, removeStorage, setStorage } from "@/assets/js/util2.js";
import router from '@/router';
import { Notify } from "vant";
import Vue from 'vue';
const wx = require('weixin-js-sdk')
const client_type = checkBrowser()//微信/支付宝环境
Vue.prototype.userInfo = null

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  // let urlArray = ['/binding']
  // if (client_type === 'wechat') {
  //   if (urlArray.includes(to.path)) {
  //     console.log(`${Vue.prototype.mifiUrl}${to.path}`)
  //     _get("/rechargeApi/v1/app/xinxun_sign_info", {
  //       url: location.href.split('#')[0]
  //     })
  //     .then(function(res) {
  //       wx.config({
  //         debug: false,
  //         appId: res.data.data.appId,
  //         timestamp: res.data.data.timestamp,
  //         nonceStr: res.data.data.noncestr,
  //         signature: res.data.data.sign,
  //         jsApiList: ["scanQRCode"],
  //         openTagList: ["wx-open-launch-weapp"]
  //       });
  //     });
  //   }
  // }
})

let routeConfig = null // 缓存动态路由配置，确保接口仅在首次跳转时调用一次

// 解决ios微信分享bug
router.beforeEach(async (to, from, next) => {

    // 1. 获取动态路由配置（仅在首次执行时通过接口获取）
  if (!routeConfig) {
    try {
      const res = await _get("/iotfive/v1/weixin/wechat_page_info")
      // 接口预期结构: { hasUpdate: boolean, list: [{ oldUrl, newUrl }] }

      routeConfig = res.data.data

      /**
       * 【动态路由自动注册】
       * 目的：解决 newUrl（如 balanceLists_v5）在 router.js 中未定义导致无法渲染的问题。
       * 逻辑：
       * 1. 预处理：扁平化路由链条。将 [v4->v5, v5->v6] 压缩为 [v4->v6]，确保每个 oldUrl 直接指向最新的 newUrl。
       * 2. 溯源注册：根据压缩后的映射，从 router.js 中查找 v4 的组件，并动态注册为 v6 的配置。
       * 3. 批量注入：使用 router.addRoutes 确保最新版本的 URL 能正确加载视图。
       */
      if (Array.isArray(routeConfig) && routeConfig.length > 0) {



        const vaildOldUrlList = []
        for (let i = 0; i < routeConfig.length; i++) {

          const isValidOldUrl = routeConfig[i].oldUrl.split('/')
          const isValidNewUrl = routeConfig[i].newUrl.split('/')
          if (isValidOldUrl.length != isValidNewUrl.length && isValidOldUrl.length > 1) {
            // console.warn(`Skipping invalid mapping: ${routeConfig[i].oldUrl} -> ${routeConfig[i].newUrl}`)
            continue
          }
          const { route } = router.resolve(routeConfig[i].oldUrl)
          const matched = route.matched


          if(matched && matched.length > 0) {
            vaildOldUrlList.push(routeConfig[i].oldUrl)
          }
        }

        console.log('Valid oldUrl list:', vaildOldUrlList) // 调试输出，查看有效的 oldUrl 列表


        const flattenedList = vaildOldUrlList.map(item => {
          let finalNewUrl = item
          let nextMapping = routeConfig.find(m => m.oldUrl === finalNewUrl)
          // console.log(`Processing mapping for ${item}:`, nextMapping) // 调试输出，查看当前处理的映射关系

          const visitedOldUrls = new Set()
          while (nextMapping) {
            if (visitedOldUrls.has(nextMapping)) {
              // console.warn(`Detected circular mapping for ${item}: ${nextMapping.oldUrl} already visited. Stopping flattening.`)
              break
            }
            visitedOldUrls.add(nextMapping)
            finalNewUrl = nextMapping.newUrl
            nextMapping = routeConfig.find(m => m.oldUrl === finalNewUrl)
            // console.log(`Flattening ${item}: finalNewUrl=${finalNewUrl}, nextMapping=`, nextMapping) // 调试输出，查看每次迭代的结果
          }

          return { oldUrl: item, newUrl: finalNewUrl }
        })

         // 更新全局配置为扁平化后的列表，供后续重定向逻辑使用
        routeConfig = flattenedList
    

        const dynamicRoutes = []
        flattenedList.forEach(item => {
          const { route } = router.resolve(item.oldUrl)
          const matched = route.matched
          // 仅当 oldUrl 是在 router.js 中真实定义的原始路由时才进行注册
          console.log(`Processing mapping: ${item.oldUrl} -> ${item.newUrl}`, matched) // 调试输出，查看匹配结果

          if (matched && matched.length > 0) {
            // 1. 处理最底层的子路由：尝试将 newUrl 转换为相对于父级的路径
            let leafPath = item.newUrl
            if (matched.length > 1) {
              const parentPath = matched[matched.length - 2].path
              if (leafPath.startsWith(parentPath)) {
                leafPath = leafPath.substring(parentPath.length).replace(/^\//, '')
              }
            }

            let current = {
              path: leafPath,
              component: matched[matched.length - 1].components.default,
              meta: matched[matched.length - 1].meta
            }

            // 2. 向上递归包裹 Layout 组件
            for (let i = matched.length - 2; i >= 0; i--) {
              let currentLevelPath = matched[i].path
              // 除了最顶层保持绝对路径，中间层级也转为相对路径
              if (i > 0) {
                const grandParentPath = matched[i - 1].path
                if (currentLevelPath.startsWith(grandParentPath)) {
                  currentLevelPath = currentLevelPath.substring(grandParentPath.length).replace(/^\//, '')
                }
              }
              current = {
                path: currentLevelPath,
                component: matched[i].components.default,
                children: [current]
              }
            }
            // console.log(`Registering dynamic route: ${item.oldUrl} -> ${item.newUrl}`, current) // 调试输出，查看动态注册的路由配置
            dynamicRoutes.push(current)
          }
        })

        if (dynamicRoutes.length > 0) {
          // 建议：如果静态路由中有 * 路由，动态注册的路由会因优先级低被拦截。
          // 此处可以将通配符重定向逻辑也动态加入，确保它在所有动态路由之后。
          // dynamicRoutes.push({ path: '*', redirect: '/' })

          router.addRoutes(dynamicRoutes)

          /**
           * 【关键修复：强制重新匹配】
           * 注册完动态路由后，必须通过 next({ ...to }) 重新触发一次路由匹配。
           * 否则当前正在进行的导航会保持之前的“未匹配”状态，导致直接访问新 URL 时页面空白。
           */
          next({ ...to, replace: true })
          return
        }

   
      }
    } catch (e) {
      console.error("获取路由配置失败", e)
      routeConfig = []
    }
  }

  console.log('Current routeConfig:', routeConfig) // 调试输出，查看当前路由配置

  // 2. 路由重定向跳转
  if (routeConfig && Array.isArray(routeConfig)) {
    let finalTarget = null
    let currentPath = to.path
    let mapping = routeConfig.find(item => item.oldUrl === currentPath)
    finalTarget = mapping

    if (finalTarget && finalTarget.oldUrl !== finalTarget.newUrl) {
      /**
       * 【版本重定向修复】
       * 匹配到旧路由或中间版本时，自动重定向至链条终点。
       * 备注：不能直接使用 ...to 展开，必须显式指定 path、query 和 hash，
       * 否则已有的 matched 信息会阻止 View 更新。设置 replace: true 防止返回死循环。
       */
      next({
        path: finalTarget.newUrl,
        query: {
          ...to.query,
          _t: to.query._t || Date.now()
        },
        hash: to.hash,
        replace: true
      })
      return
    }
  }

  Vue.prototype.mifiUrl = location.origin

  if (location.href.indexOf('binding') != -1 && location.href.indexOf('?') != -1) {
    setStorage('check_imei', to.query.imei || '')
  }

  if ((location.href.indexOf('activity') != -1 && location.href.indexOf('?') != -1) || (location.href.indexOf('notMobile') != -1 && location.href.indexOf('unicom/usage') != -1)) {
    var query = {};
    location.search.substring(1).split('&').forEach(item => {
      var items = item.split("=")
      if (items[1]) {
        query[items[0]] = items[1]
      }
    })
    setStorage('query', JSON.stringify(query))
  }


  if (!to.meta.login && to.meta.login != false && !getUrlParam('hidePay')) {
    if (client_type == 'wechat' || client_type == 'alipay' || client_type == 'app') {
      if (getStorage('token')) {
        if (!Vue.prototype.userInfo) {
          let router = await getUserInfo()
          next(router)
        } else {
          next()
        }
      } else {
        if (client_type == 'app') { // 从app内获取token数据传递给网页
          let UA = navigator.userAgent.toLowerCase()
          if (/(ylkids_android)/.test(UA)) {
            let str3 = window.jsInterface.GetToken()
            localStorage.setItem('token', str3)
          } else if (/(ios1.1.0)/.test(UA)) {
            window.webkit.messageHandlers.getIosToken.postMessage(null)
          }
          setTimeout(() => {
            if (getStorage('token')) {
              // 重新刷新界面 通过getUserInfo获取用户信息
              router.go(0)
            } else {
              Notify({ message: '获取APP Token失败' })
            }
          }, 500)
        } else {
          const url = await authorizedRediect()
          location.href = url
        }

      }
    } else {
      next()
    }
  } else {
    next()
  }

})


function getUserInfo() {
  return new Promise((resolve) => {
    _get("/accountCenter/v2/user/info?" + util.carsParam({}, 'get'))
      .then(res => {
        if (res.data.error === 0) {
          if (res.data.data && JSON.stringify(res.data.data) !== '{}') {
            Vue.prototype.userInfo = res.data.data
            setStorage("userCenterInfo", res.data.data, "obj")
            if (client_type == "app") {
              setStorage("userInfo", {
                city: "",
                country: "",
                headimgurl: res.data.data.avatar,
                language: "",
                nickname: res.data.data.nickname,
                openid: "",
                privilege: [],
                province: "",
                sex: res.data.data.gender,
                unionid: "",
              }, "obj")
            }
            getGold()
          } else {
            Notify({ message: '请求失败' })
          }
        } else if (res.data.error === 11002) {
          refreshToken()
        } else if (res.data.error === 10007) {
          let curTimeStamp = (Date.parse(new Date()) / 1000),
            timeSpan = res.data.extra - curTimeStamp;
          setStorage('timeSpan', timeSpan);
          getUserInfo()
        } else if (res.data.error === 20014) {
          Notify({ message: '请求超时' })
        } else if (res.data.error === 30037) {
          removeStorage('token')
          removeStorage('userCenterInfo')
          resolve('/bindAccount_v4')
        } else {
          Notify({ message: res.data.msg })
        }
        resolve()
      })
  })
}

function authorizedRediect() {
  const state = Math.random().toString(36).substr(2) + new Date().getTime()
  setStorage('state', state)
  setStorage('authorized_redirect_uri', GetUrlRelativePath())
  return new Promise((resolve, reject) => {
    _get('/accountCenter/v2/oauth/authorize?' + util.carsParam({
      client_type: client_type,
      redirect_uri: Vue.prototype.mifiUrl + '/mifi/authority_v2',
      scope: 'userinfo',
      state: state
    }))
      .then(res => {
        resolve(res.data.data)
      })
  })

}

function refreshToken() {
  _get("/accountCenter/v2/auth/refresh?" + util.carsParam({
    token: getStorage('token')
  }, 'get'))
    .then((res) => {
      if (res.data.error === 0) {
        setStorage('token', res.data.data);
        getUserInfo()
      }
    })
}

/**
 * 金币登录
 */
function getGold() {
  var { user_id } = JSON.parse(getStorage("userCenterInfo")).account;
  var { age, gender, nickname, mobile, created } = JSON.parse(getStorage("userCenterInfo"));
  var { headimgurl } = JSON.parse(getStorage("userInfo"));
  // console.log(user_id, age, gender, nickname, mobile, headimgurl)
  var requestData = {
    user_id: user_id,
    age: age,
    gender: gender,
    nickname: btoa(encodeURI(nickname)),
    mobile: mobile,
    portrait: headimgurl,
    created: created
  }
  _post("/rechargeApi/v1/app/users/login", requestData).then(res => {
    const data = res.data.data;
    if (res.data.state == 1) {
      // this.myGold = data.gold;
      // if (this.myGold >= 100000000) {
      //     this.myGold = (this.myGold / 100000000).toFixed(2) + '亿'
      // }
    } else {
      // Notify({message: res.data.msg})
    }
  })
}